import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

/**
 * Um componente de rota que verifica se o usuário logado possui uma permissão específica.
 * @param {{children: React.ReactNode, permission: string}} props
 * @returns {React.ReactNode} Retorna o componente filho se o usuário tiver a permissão, caso contrário, redireciona.
 */
const PermissionRoute = ({ children, permission }) => {
  const token = localStorage.getItem('accessToken');

  // Se não há token, o usuário não está logado. Redireciona para o login.
  if (!token) {
    return <Navigate to="/login" />;
  }

  try {
    const decodedToken = jwtDecode(token);
    // As permissões são armazenadas no payload do token como um array de strings.
    const userPermissions = decodedToken.permissions || [];
    
    // Verifica se a permissão necessária está na lista de permissões do usuário.
    if (userPermissions.includes(permission)) {
      // Se tiver permissão, renderiza o componente filho (a página).
      return children;
    } else {
      // Se não tiver permissão, redireciona para a página inicial.
      // Opcionalmente, poderia redirecionar para uma página "Acesso Negado".
      return <Navigate to="/" />;
    }
  } catch (error) {
    // Se o token for inválido ou expirado, o jwtDecode vai gerar um erro.
    console.error("Token inválido:", error);
    // Redireciona para o login para que o usuário possa se autenticar novamente.
    return <Navigate to="/login" />;
  }
};

export default PermissionRoute;
